module.exports = __webpack_public_path__ + "img/love1.5e58502c.png";